module.exports = __webpack_public_path__ + "img/boxy_background_2.a323c274.jpg";